// extracted by mini-css-extract-plugin
export default {"group":"Tooltip--group--n8WWI","infoBox":"Tooltip--infoBox--ZM+mo","value":"Tooltip--value--BYKCH"};